import slick from 'slick-carousel';
import slickGoTo from 'slick-carousel';

export default function carouselMobile() {
  if ($(window).width() < 768) {
    async function initCarousel() {
      await $('[data-carousel-mobile]').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<button class="slick-prev"><i class="fas fa-angle-left"></i></button>',
        nextArrow: '<button class="slick-next"><i class="fas fa-angle-right"></i></button>'
      })
      // let position;
      // $.each($('[data-menuinternal-name].active').closest('.slick-slide'), (index, el) => {
      //   if ($(el).data('slick-index') >= 0) {
      //     position = $(el).data('slick-index')
      //   }
      // })
      // await $('[data-carousel-mobile]').slick('slickGoTo', position);
    }
    initCarousel();
  }
}